<div class="thanks-feedback">
    <img src="../../../../assets/images/wos_feedback.svg" alt="">
     
    <h4 class="mt-3">Thank you for your feedback!</h4>

    <p>Your input helps us create an even better app experience. We’re so grateful you took the time to share your thoughts!</p>
    <button class="submit-btn mt-4" (click)="RedirectToHome()">Return to home</button>
</div>